@if (visible) {
  <div
    data-testid="contact-qa-tools"
    class="mb-3 w-full rounded-2xl border border-amber-200 bg-amber-50/40 dark:border-amber-500/30 dark:bg-amber-500/5">
    <div class="px-5 py-4 sm:px-6 sm:py-5">
      <h3 class="text-base font-medium text-gray-800 dark:text-white/90">QA tools (pre-production)</h3>
      <p class="mt-1 text-sm text-gray-600 dark:text-gray-400">
        This contact is a seeded QA fixture. These actions do not exist on the live site.
      </p>
    </div>
    <div class="space-y-4 border-t border-amber-100 p-5 dark:border-amber-500/20 sm:p-6">
      <div class="flex flex-wrap items-center gap-3">
        <app-button
          [type]="'button'"
          [style]="'primary'"
          [label]="sending ? 'Sending…' : 'Send a quote email'"
          [disabled]="sending"
          data-testid="contact-qa-send-quote-email"
          (click)="sendQuoteEmail()"
        ></app-button>
        <span class="text-sm text-gray-600 dark:text-gray-400">
          Creates a quote for this fixture contact and sends the same quote email a website quote sends.
        </span>
      </div>

      <div class="flex flex-wrap items-center gap-3">
        <select
          class="h-9 rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
          aria-label="Customer email to send"
          data-testid="contact-qa-customer-email"
          [(ngModel)]="customerEmail">
          @for (option of customerEmails; track option.key) {
            <option [value]="option.key">{{ option.label }}</option>
          }
        </select>
        <app-button
          [type]="'button'"
          [style]="'secondary'"
          [label]="sending ? 'Sending…' : 'Send this email'"
          [disabled]="sending"
          data-testid="contact-qa-send-customer-email"
          (click)="sendCustomerEmail()"
        ></app-button>
        <span class="text-sm text-gray-600 dark:text-gray-400">
          Sends a fresh copy to this fixture contact, built exactly as the real email is.
        </span>
      </div>

      @if (result) {
        <div
          data-testid="contact-qa-send-result"
          class="rounded-lg border border-green-200 bg-green-50/70 px-3 py-2 text-sm text-green-700 dark:border-green-500/30 dark:bg-green-500/10 dark:text-green-300">
          {{ result }}
          @if (mailCatcherUrl) {
            <a class="underline" [href]="mailCatcherUrl" target="_blank" rel="noopener">{{ mailCatcherUrl }}</a>
          }
        </div>
      }

      @if (sendError) {
        <div class="rounded-md bg-error-50 p-3 text-sm text-error-700">{{ sendError }}</div>
      }
    </div>
  </div>
}
